import { useEffect } from "react";
import { updateRingtoneVolume } from "./ringtone-volume";
import { RINGTONE_VOLUME_CHANGE_EVENT } from "./utils";

export function useRingtoneVolumeSync(): void {
  useEffect(() => {
    window.addEventListener(RINGTONE_VOLUME_CHANGE_EVENT, updateRingtoneVolume);
    return () =>
      window.removeEventListener(
        RINGTONE_VOLUME_CHANGE_EVENT,
        updateRingtoneVolume,
      );
  }, []);
}
